import {
  IconButton,
  Box,
  Typography,
  Link
} from '@mui/material';
import { CopyAll, PictureAsPdf } from '@mui/icons-material';
import { getQuotationsGridNavigationItem } from '../QuotationList/utils';
import { URLS } from '../../apis/urls';
import { QuotationDocumentStatus } from '../../_helpers';

export const getPerson1Details = (t, data) => {
  const p1 = data?.buyerRenter?.p1 || {};

  return [
    { title: t('general.lastName'), value: p1.lastName || "" },
    { title: t('general.namePrefixes'), value: p1?.middleName?.name || "" },
    { title: t('general.initials'), value: p1.initials || "" },
    { title: t('general.firstName'), value: p1.firstName || "" },
    { title: t('buyersGuide.buyersInfo.phonePrivate'), value: p1.telephonePrivate || "" },
    { title: t('buyersGuide.buyersInfo.phoneWork'), value: p1.telephoneWork || "" },
    { title: t('buyersGuide.mobile'), value: p1.mobile || "" },
    { title: t('general.emailPrivate'), value: p1.emailPrivate || "" },
    { title: t('buyersGuide.buyersInfo.emailWork'), value: p1.emailWork || "" },
    { title: t('buyersGuide.quotation.loginEmail'), value: p1.loginEmail || "" }
  ];
};


export const getPerson2Details = (t, data) => {
  const p2 = data?.buyerRenter?.p2 || {};

  return [
    { title: t('general.lastName'), value: p2.lastName || "" },
    { title: t('general.namePrefixes'), value: p2?.middleName?.name || "" },
    { title: t('general.initials'), value: p2.initials || "" },
    { title: t('general.firstName'), value: p2.firstName || "" },
    { title: t('buyersGuide.buyersInfo.phonePrivate'), value: p2.telephonePrivate || "" },
    { title: t('buyersGuide.buyersInfo.phoneWork'), value: p2.telephoneWork || "" },
    { title: t('buyersGuide.mobile'), value: p2.mobile || "" },
    { title: t('general.emailPrivate'), value: p2.emailPrivate || "" },
    { title: t('buyersGuide.buyersInfo.emailWork'), value: p2.emailWork || "" },
    { title: t('buyersGuide.quotation.loginEmail'), value: p2.loginEmail || "" }
  ];
};
export const getOrganizationInfo = (t, data) => {
  const org = data?.buyerRenter?.org || {};

  return [
    { title: t('general.searchName'), value: org.searchName || "" },
    { title: t('general.namePrefixes'), value: org?.middleName?.name || "" },
    { title: t('general.initials'), value: org.initials || "" },
    { title: t('general.name'), value: org.name || "" },
    { title: t('general.telephone'), value: org.telephone || "" },
    { title: t('general.email'), value: org.email || "" },
    { title: t('general.website'), value: org.website || "" }
  ];
};
export const getRelationDetails = (t, data) => {
  const org = data?.buyerRenter?.org || {};

  return [
    { title: t('general.lastName'), value: org.lastName || "" },
    { title: t('general.namePrefixes'), value: org?.middleName?.name || "" },
    { title: t('general.initials'), value: org.initials || "" },
    { title: t('general.firstName'), value: org.relationName || "" },
    { title: t('general.function'), value: org.relationFunctionName || "" },
    { title: t('general.department'), value: org.relationDepartment || "" },
    { title: t('buyersGuide.businessEmail'), value: org.relationEmail || "" },
    { title: t('general.telephone'), value: org.relationTelephone || "" },
    { title: t('buyersGuide.mobile'), value: org.relationMobile || "" },
  ];
};

export const getQuotationSettings = (t,quotationDetails,setDocumentViewer)=>{
  const quote = quotationDetails?.quote;
    return [
        { title: t('buyersGuide.quotation.number'), value: quote?.quoteNo } ,
        { title: t('buyersGuide.quotation.closingDate'), value:  quote?.closingDate},
        { title: t('general.signature'), value:  <Typography component='p' variant='caption'>{t(`db.domain.ondertekening.${quote?.quotationSignatureType}`) || ''}</Typography>},
        { title: t('contract.details.signing.numberOfSignatures'), value:  quote?.numberOfSignatories },
        { title: t('buyersGuide.quotation.amountsInclVAT'), value:  quote?.amountInclVAT },
      ...(quote?.drawingFile
        ? [{
          title: t('buyersGuide.quotation.drawing'),
          value: (
            <IconButton
              size='small'
              onClick={() => {
                if (!quote?.drawingFile?.id) return;
                setDocumentViewer({
                  open: true,
                  documents: [
                    {
                      uri: `${URLS.GET_ATTACHMENT}${quote.drawingFile.id}`,
                      name: quote.drawingFile.description,
                      fileType: 'application/pdf',
                    },
                  ],
                });
              }}
              >
              <PictureAsPdf fontSize='small' color='error' /> </IconButton>),
        }] : []),
    ];
}
export const getModeOfSigningConfirmation = (t, quotationDetails, onCopyLink) => {
  const parties = quotationDetails?.parties;
  const party1 = parties?.[0];
  const party2 = parties?.[1];
  const signingPartyConfig = []
  if (party1) {
    signingPartyConfig.push({
      title:party1?.name ,
      value:  <Box display="flex" alignItems="center" justifyContent="space-between">
      <Link target="_blank" href={`${party1.url ?? "#"}`}  underline="hover"><Typography variant='caption' component={'p'}>{t('buyersGuide.quotation.clickHereToSign')}</Typography></Link>
      <IconButton size="small" onClick={() => onCopyLink(party1.url)}>
        <CopyAll fontSize='small' />
      </IconButton>
    </Box>,
    });
  }
  if (party2) {
    signingPartyConfig.push({
      title:party2?.name ,
      value:  <Box display="flex" alignItems="center" justifyContent="space-between">
      <Link target="_blank" href={`${party2.url ?? "#"}`}  underline="hover"><Typography variant='caption' component={'p'}>{t('buyersGuide.quotation.clickHereToSign')}</Typography></Link>
      <IconButton size="small" onClick={() => onCopyLink(party2.url)}>
        <CopyAll fontSize='small' />
      </IconButton>
    </Box>,
    });
  }

  return signingPartyConfig;

} 

export const getRentersInformation = (t, data) => {
  const br = data?.buyerRenter;

  if (!br) return [];

  // Buyer
  if (br.type === 0) {

    const result = [{
      title: `${t('general.person')} 1`,
      details: getPerson1Details(t, data),
    }];

    if (br.p2)
      result.push({
        title: `${t('general.person')} 2`,
        details: getPerson2Details(t, data),
      });

    return result;
  }

  return [
    {
      title: t('general.organisation'),
      details: getOrganizationInfo(t, data)
    },
    {
      title: t('workOrders.relation'),
      details: getRelationDetails(t, data)
    }
  ];
};


export const getDynamicSettingInfo = (t,quotationDetails,setDocumentViewer, onCopyLink) =>{
  const dynamicSettings = []
  const documentStatus = quotationDetails?.quote?.documentStatus;
  
  dynamicSettings.push(  {
    title: t('buyersGuide.quotation.setting'),
    details: getQuotationSettings(t,quotationDetails,setDocumentViewer),
    isHiddenListItemIcon: true,
    isDisabled: false,
})

  if(quotationDetails?.parties?.length > 0 && documentStatus === QuotationDocumentStatus.PENDING){
    dynamicSettings.push({
        title: t('buyersGuide.quotation.modeOfSignConformation'),
        details: getModeOfSigningConfirmation(t,quotationDetails, onCopyLink),
        isHiddenListItemIcon: true,
        isDisabled: false,
    })
  }
  return dynamicSettings;
  
}
export const getQuotationInfoNavigationItem = (t,quotationDetails )=>{
    const to = "/offertes"
    const quotationsGridNavigationItems = getQuotationsGridNavigationItem(t) 
    const breadCrumbTitle = quotationDetails?.quote?.quoteNo
    return {
    breadCrumbs: [ ...quotationsGridNavigationItems?.breadCrumbs , { title: t("buyersGuide.quotations") + " - " +breadCrumbTitle, breadCrumbTitle : breadCrumbTitle , to}],
    tabs: [...quotationsGridNavigationItems?.tabs, { title: t('general.form'), to }]
    }
}